module.exports = __webpack_public_path__ + "img/contact.c718e69b.svg";